/**
 * Store setup assistance: the hours meter card, the assistance page, the
 * request dialog and durations. Conventions: see `common.ts`.
 */
const setupAssistance: Record<string, string> = {
  'duration.none': 'none',
  'duration.under_a_minute': 'under a minute',
  'duration.minutes_one': '{count} minute',
  'duration.minutes_other': '{count} minutes',
  'duration.hours_one': '{count} hour',
  'duration.hours_other': '{count} hours',
  remaining: '{duration} remaining',
  unlimited_label: 'Unlimited setup assistance',

  title: 'Store setup assistance',
  request_help: 'Request setup help',

  'card.unlimited': 'Your plan includes unlimited setup assistance.',
  'card.hours_used': '{used} / {allocated} hours used',
  'card.progress_label': 'Setup assistance hours used',
  'card.working_now': '{name} is working in your account now.',
  'card.someone_from_team': 'Somebody from NeonCarts',
  'card.ending_session': 'Ending…',
  'card.end_session': 'End this session',
  'card.exhausted': 'Your store setup assistance hours are exhausted.',
  'card.exhausted_detail': 'Your current plan includes {allocated} hours and you have used {used}.',
  'card.upgrade': 'Upgrade your plan to get additional hours',
  'card.picking_up': '{name} is picking this up.',
  'card.in_queue': 'Your request is in the queue.',

  'page.load_error': 'Could not load your setup assistance.',
  'page.intro':
    'Our team can set your shop up for you - products, pages, your theme and shipping. Ask for help and somebody will go into your account and do the work. Your plan includes {allowance}, and only the time somebody is actually working is counted.',
  'page.allowance_unlimited': 'unlimited time',
  'page.allowance_hours': '{hours} hours',
  'page.revoke_error': 'Could not end that session.',
  'page.open_request': 'Your open request',
  'page.quoted_note': '“{note}”',
  'page.withdraw': 'Withdraw',
  'page.withdraw_error': 'Could not withdraw that request.',
  'page.history_title': 'What has been done',
  'page.history_empty_title': 'No setup help yet',
  'page.history_empty_description': 'When our team works on your shop, what they did appears here.',
  'page.handled_by': 'Handled by {name}',
  'page.time_used': 'Time used',
  'page.working_now': 'working now',

  'status.REQUESTED': 'Waiting for someone to pick it up',
  'status.ASSIGNED': 'Assigned',
  'status.IN_PROGRESS': 'In progress',
  'status.COMPLETED': 'Completed',
  'status.CANCELLED': 'Withdrawn',
  'status.DECLINED': 'Declined',

  'dialog.sending': 'Sending…',
  'dialog.send': 'Send request',
  'dialog.intro':
    'Tell us what you would like help with. Somebody from our team will go into your account and set it up for you.',
  'dialog.note_label': 'What do you need help with?',
  'dialog.note_placeholder': 'I have 30 products in a spreadsheet and I cannot work out shipping rates.',
  'dialog.access_notice':
    'While your request is open, a colleague from NeonCarts can make changes to your products, pages, theme and shipping. They cannot see or change your billing, your team, your orders or your payment keys. You can end their session at any time, and withdrawing the request removes their access.',
  'dialog.send_error': 'Could not send that request.',
};

export default setupAssistance;
